var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"min-h-screen bg-gray-light overflow-x-hidden"},[_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }